module.exports = __webpack_public_path__ + "static/img/logo.b510cb8f.png";